import { ILoyaltyHistoryData } from "../api/types";
import $api from "../http";
import { ILoyaltyBalance, ILoyaltyExchange, ILoyaltyHistory } from "../models/Loyalty";

class LoyaltyServiceClass {
  getBalance(userId: string | null) {
    return $api.get<ILoyaltyBalance>(`api/loyalty-history/user-balance/${userId}`);
  }

  getLoyaltyExchanges() {
    return $api.get<ILoyaltyExchange[]>(`api/loyalty-settings/exchanges-for-customer`);
  }

  async getLoyaltyHistory({ userId, limit, skip }: ILoyaltyHistoryData) {
    let queryString = "?";
    if (userId) {
      queryString += `&userId=${userId}`;
    }
    if (limit) {
      queryString += `&limit=${limit}`;
    }
    if (skip) {
      queryString += `&skip=${skip}`;
    }
    return $api.get<{ historyItemsLength: number; historyItems: ILoyaltyHistory[] }>(
      `api/loyalty-history${queryString}`
    );
  }
}

export const LoyaltyService = new LoyaltyServiceClass();
